import { useRef, useEffect } from 'react';
import { NativeSelect, Theme, useTheme } from '@mui/material';

interface AutoWidthSelectProps {
    values: string[];
    selected: string;
    setSelected: (s: string) => void;
}

const selectStyle = {
    border: "none",
    padding: "5px",
    borderRadius: "5px",
    font: 'inherit',
}

export function AutoWidthSelect(props: AutoWidthSelectProps) {
    const selectRef = useRef<HTMLSelectElement>(null);
    const spanRef = useRef<HTMLSpanElement>(null);
    const theme = useTheme<Theme>();

    useEffect(() => {
        if (!selectRef.current || !spanRef.current) return;
        spanRef.current.textContent = props.selected;
        const width = spanRef.current.offsetWidth + 35; // 30px for arrow/padding
        selectRef.current.style.width = `${width}px`;
    }, [props.values, props.selected])

    return (
        <>
            <NativeSelect
                ref={selectRef}
                onChange={(e) => { props.setSelected(e.target.value) }}
                style={{
                    ...selectStyle,
                    backgroundColor: theme.bee.barBackground,
                    color: theme.bee.text,
                }}
                value={props.selected}
            >
                {props.values.map((opt) => (
                    <option
                        key={opt}
                        value={opt}
                        style={{
                            ...selectStyle,
                            backgroundColor: theme.bee.barBackground,
                            color: theme.bee.text,
                        }}>
                        {opt}
                    </option>
                ))}
            </NativeSelect>
            {/* hidden span for measuring */}
            <span
                ref={spanRef}
                style={{
                    visibility: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    font: 'inherit',
                    padding: 0,
                    margin: 0
                }}
            />
        </>
    );
}
